import intlTelInput from "intl-tel-input";
import loadModuleScript from "./moduleScript";
import { attachPhoneFormat, PHONE_UTILS } from "../basics/phoneField";

const userInfo = {
    data() {
        return {
            modules: {},
            iti: null,
            // the invoice address: its fields depend on the country (AddressFields)
            countries: [],
            invoiceAddr: AddressFields.blank(),
            invoiceCountry: null,
            success_message:false,
            phoneError: false,
            phoneErrorCode: 0,
            userInfo: {
                first_name: "",
                last_name: "",
                is_business: false,
                crmItemContact: [
                    {
                        email: "",
                        phone: "",
                    },
                ],
            },
            errors: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
            },
            // the invoice address fields the server refused (the AddressFields flags), and an error no field
            // shows - without them a refused save looked like nothing happened
            invoiceErrors: {post: false, city: false, state: false, area: false, street: false, house: false},
            generalError: "",
        };
    },
    watch: {
        'userInfo.country_id'(id) {
            this.invoiceCountry = null;
            if (id) AddressFields.country(id).then((row) => { if (String(this.userInfo.country_id) === String(id)) this.invoiceCountry = row; });
        },
    },
    methods: {
        getData() {
            let loginToken = Cookies.getItem("login_token");
            if(!loginToken){
                location.href = (window.SHOP_BASE || "") + "/login";
                return;
            }
            ProfileSession.userInfo(loginToken, true).then((userInfo) => {
                if (userInfo) {
                    this.setUserInfo(userInfo);
                }
            });
        },
        setUserInfo(userInfo) {
            this.userInfo.id = userInfo.id;
            this.userInfo.first_name = userInfo.first_name;
            this.userInfo.last_name = userInfo.last_name;
            this.userInfo.is_business = userInfo.is_business ? true : false;
            if (userInfo.crmItemContacts) {
                this.userInfo.crmItemContact = userInfo.crmItemContacts;
            } else if (userInfo.crmItemContact) {
                this.userInfo.crmItemContact = [userInfo.crmItemContact];
            }
            this.userInfo.country_id = userInfo.country_id ? Number(userInfo.country_id) : null;
            this.invoiceAddr = AddressFields.blank({
                post_code: userInfo.invoice_post_code, city: userInfo.invoice_city, street: userInfo.invoice_street,
                house: userInfo.invoice_house, area: userInfo.invoice_area, state: userInfo.invoice_state,
            });
            if (!this.countries.length) this.loadCountries();

            setTimeout(() => {
                if (document.querySelector('link[href*="intlTelInput.css"]')) return;
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/css/intlTelInput.css";
                document.head.appendChild(link);
            },0);
            const _this = this;
            setTimeout(() => {
            if(_this.iti == null) {
                const phoneInput = document.querySelector("#phone");
                this.iti = intlTelInput(phoneInput, {
                    separateDialCode: true,
                    initialCountry: user_country?.toLowerCase() ?? "hu",
                    utilsScript: PHONE_UTILS,
                });
                attachPhoneFormat(this.iti, phoneInput);
            }

            forms.load();
            },600);
        },
        // the countries an invoice can be issued to (the checkout's list)
        loadCountries() {
            fetch("/api/countries", {headers: http.headers()}).then((r) => r.json()).then((list) => {
                this.countries = (list || []).map((c) => ({id: Number(c.id), name: c.name}))
                    .sort((a, b) => String(a.name).localeCompare(String(b.name)));
                // no saved country: the shop's own
                if (!this.userInfo.country_id && typeof country !== "undefined" && country) this.userInfo.country_id = Number(country);
            }).catch(() => {});
        },
        saveToLocalStorage(userInfo) {
            let token = Cookies.getItem("login_token");
            if (token) {
                localStorage.setItem(token, JSON.stringify(userInfo));
            }
        },
        saveUserInfo(event) {
            event.preventDefault();

            if (this.iti != null) {
                this.phoneErrorCode = 0;
                this.phoneError = false;
                this.userInfo.crmItemContact.phone = this.iti.getNumber();
                if(!this.iti.isValidNumber()){
                    this.phoneErrorCode = this.iti.getValidationError();
                    if(this.phoneErrorCode !== 4 && this.phoneErrorCode !== 0) {
                        this.phoneError = true;
                    }
                }
            }

            if(this.phoneError){
                return;
            }

            const a = this.invoiceAddr;
            Object.assign(this.userInfo, {
                invoice_post_code: a.postcode, invoice_city: a.city, invoice_street: a.street,
                invoice_house: a.house, invoice_area: a.area, invoice_state: a.state,
            });
            let bodyContent = {
                ...this.userInfo,
                token: Cookies.getItem("login_token"),
            };
            fetch("/api/profile/update", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(bodyContent),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.success_message = false;
                    if (data.code === 200) {
                        this.setUserInfo(data.data);
                        this.saveToLocalStorage(data.data);
                        this.initErrors();
                        this.success_message = true;
                    } else if (data.errors) {
                        this.showUnmappedErrors(data.errors);
                        if (data.errors["first_name"])
                            this.errors.first_name =
                                data.errors["first_name"][0];
                        if (data.errors["last_name"])
                            this.errors.last_name = data.errors["last_name"][0];
                        if (data.errors["crmItemContact.email"])
                            this.errors.email =
                                data.errors["crmItemContact.email"][0];
                        if (data.errors["crmItemContact.phone"])
                            this.errors.phone =
                                data.errors["crmItemContact.phone"][0];
                    } else {
                        this.generalError = data.message || (window.lang && lang.profile && lang.profile.save_failed) || "";
                    }
                })
                .catch((error) => {
                    this.success_message = false;
                    this.generalError = (window.lang && lang.profile && lang.profile.save_failed) || "";
                    console.log("error", error);
                });
        },
        // the keys the form has no own place for: the invoice address fields get their flags, the rest one message
        showUnmappedErrors(errors) {
            this.initErrors();
            const fields = {
                invoice_post_code: "post", invoice_city: "city", invoice_state: "state",
                invoice_area: "area", invoice_street: "street", invoice_house: "house",
            };
            const own = ["first_name", "last_name", "crmItemContact.email", "crmItemContact.phone"];
            const other = [];
            for (const key of Object.keys(errors)) {
                if (fields[key]) {
                    this.invoiceErrors[fields[key]] = true;
                } else if (!own.includes(key)) {
                    const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                    if (message) other.push(String(message));
                }
            }
            this.generalError = other.join(" ");
        },
        initErrors() {
            this.errors.first_name = "";
            this.errors.last_name = "";
            this.errors.email = "";
            this.errors.phone = "";
            this.generalError = "";
            for (const key of Object.keys(this.invoiceErrors)) this.invoiceErrors[key] = false;
        },
        loadModule(name, callback) {
            this.module = name;
            if (this.modules[name] === undefined) {
                loadModuleScript(name).then(() => {
                    if (this.modules[name] === undefined) {
                        this.modules[name] = window[`${name}App`].mount(`#${name}`);
                        forms.load();
                    }
                    if (callback) callback();
                });
            } else {
                if (callback) callback();
            }
        },
        loadDialogModule(name, type) {
            let modules = this.modules;
            this.loadModule(name, () => {
                this.modules[name].openDialog(() => {
                    if(type === 'profile') {
                        this.deleteAccount();
                    }
                });
            });
        },
        deleteAccount() {
            let token = Cookies.getItem("login_token");
            let userId = this.userInfo.id;
            let bodyContent = {
                token: token,
                user_id: userId,
            };
            fetch("/api/profile/delete-account", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(bodyContent),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.code === 200) {
                        this.clearLocalStorage();
                        window.location.pathname = (window.SHOP_BASE || "") + "/login";
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
        clearLocalStorage(){
            let token = Cookies.getItem("login_token");
            Cookies.setItem("login_token", "");
            localStorage.setItem(token, {});
        }
    },
    created() {
        this.getData();
    },
};

// Global cart object
const USERINFO = {
    vue: null,
    loaded: false,
    load() {
        if (this.loaded) {
            return;
        }
        if (document.getElementById("user_info") !== null) {
            this.loaded = true;
            const app = Vue.createApp(userInfo);
            app.component("address-fields", AddressFields);
            this.vue = app.mount("#user_info");
        }
    },
};
window.USERINFO = USERINFO;

window.addEventListener("DOMContentLoaded", () => {
    USERINFO.load();
});
window.addEventListener("load", () => {
    USERINFO.load();
});

if (document.readyState !== "loading") {
    USERINFO.load();
}
